import { createContext, useState, useEffect, useContext } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Al montar, verificamos si ya hay sesión (cookie)
    useEffect(() => {
        const checkAuth = async () => {
            try {
                const res = await api.get('/auth/me');
                setUser(res.data.user);
            } catch (error) {
                setUser(null);
            } finally {
                setLoading(false);
            }
        };
        checkAuth();
    }, []);

    const login = async (email, password) => {
        const res = await api.post('/auth/login', { email, password });
        setUser(res.data.user);
        return res.data;
    };

    //const register = async (email, password, nombre, apellido, telefono) => {
    //  return await api.post('/auth/register', { email, password, nombre, apellido, telefono });
    //};

    const register = async (userData) => {
        return await api.post('/auth/register', userData);
    };

    const logout = async () => {
        await api.post('/auth/logout');
        setUser(null);
    };

    const forgotPassword = async (email) => {
        return await api.post('/auth/forgot-password', { email });
    };

    const updateUser = (userData) => {
        setUser((prev) => ({ ...prev, ...userData }));
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, forgotPassword, updateUser }}>
            {children}
        </AuthContext.Provider>
    );

};